import warrantyBadge from "@/assets/badges/warranty-badge.png";
import ecoFriendlyBadge from "@/assets/badges/eco-friendly-badge.png";
import satisfactionBadge from "@/assets/badges/satisfaction-badge.png";
import wholesaleBadge from "@/assets/badges/wholesale-badge.png";
import factoryDirectBadge from "@/assets/badges/factory-direct-badge.png";
import premiumQualityBadge from "@/assets/badges/premium-quality-badge.png";

const badges = [
  { label: "7 Year Warranty", image: warrantyBadge },
  { label: "Eco Friendly", image: ecoFriendlyBadge },
  { label: "100% Satisfaction Guarantee", image: satisfactionBadge },
  { label: "Wholesale", image: wholesaleBadge },
  { label: "Factory Direct Supply", image: factoryDirectBadge },
  { label: "Premium Quality", image: premiumQualityBadge },
];

const BadgeCard = ({ label, image }: { label: string; image: string }) => (
  <div className="group flex-shrink-0 w-[160px] sm:w-[180px] md:w-[200px] cursor-pointer">
    <div className="flex flex-col items-center gap-3 rounded-xl border border-[hsl(120,12%,90%)] bg-background p-5 shadow-sm transition-all duration-300 group-hover:scale-[1.03] group-hover:shadow-md">
      <img
        src={image}
        alt={label}
        className="h-20 w-20 object-contain"
        loading="lazy"
      />
      <p className="text-center text-xs font-semibold uppercase tracking-wider text-foreground/80 leading-tight">
        {label}
      </p>
    </div>
  </div>
);

export function TrustBadgesSection() {
  // Duplicate badges for seamless infinite scroll
  const allBadges = [...badges, ...badges];

  return (
    <section className="relative border-t border-border/30 border-b border-border/30 bg-[hsl(80,14%,97%)] py-10 md:py-14">
      <div className="container mb-8 text-center">
        <h2 className="text-2xl font-bold text-foreground md:text-3xl">
          Trusted Quality. Proven Results.
        </h2>
        <p className="mt-2 text-sm text-muted-foreground">
          Badges that back our products, service, and supply.
        </p>
      </div>

      {/* Marquee container */}
      <div className="group/marquee relative overflow-hidden">
        <div className="flex w-max animate-[marquee_30s_linear_infinite] gap-6 px-4 group-hover/marquee:[animation-play-state:paused]">
          {allBadges.map((badge, i) => (
            <BadgeCard key={`${badge.label}-${i}`} label={badge.label} image={badge.image} />
          ))}
        </div>
      </div>
    </section>
  );
}
